import { ConfluenceSiteAri } from '@atlassian/ari/confluence/site';
import { StudioWorkspaceAri } from '@atlassian/ari/studio/workspace';

import { AccessStatus } from '@confluence/session-data/entry-points/SiteInformationQuery.ts';

import type { useStudioPermissionsLinkedWorkspaceQuery$data } from '../hooks/__generated__/useStudioPermissionsLinkedWorkspaceQuery.graphql.ts';

type StudioPermissionsEligibilityInput = {
	cloudId: string | null | undefined;
	isRovoLLMEnabled: boolean | null | undefined;
	accessStatus: AccessStatus | null | undefined;
	isLoggedIn: boolean | null | undefined;
};

export const hasStudioPermissionsBaseEligibility = ({
	cloudId,
	isRovoLLMEnabled,
	accessStatus,
	isLoggedIn,
}: StudioPermissionsEligibilityInput): boolean => {
	const isAnonymousUser = accessStatus === AccessStatus.ANONYMOUS_ACCESS || !isLoggedIn;
	return Boolean(isRovoLLMEnabled && !isAnonymousUser && cloudId);
};

export const getStudioWorkspaceLookupSiteAri = (
	cloudId: string | null | undefined,
): string | null => {
	if (!cloudId) {
		return null;
	}
	try {
		return ConfluenceSiteAri.create({ siteId: cloudId }).toString();
	} catch {
		return null;
	}
};

// A site is linked to at most one Studio workspace.
export const getLinkedStudioWorkspaceAri = (
	data: useStudioPermissionsLinkedWorkspaceQuery$data | null | undefined,
): StudioWorkspaceAri | null => {
	const workspaceAri = data?.admin_unitLinkedResource?.links?.edges?.[0]?.node?.id;
	return workspaceAri && StudioWorkspaceAri.check(workspaceAri)
		? StudioWorkspaceAri.parse(workspaceAri)
		: null;
};
